import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "../images/logo.png";
import Avatar from "../images/avatar.png";

const NAV = [
    { label: "Dashboard",         to: "/admin",                 end: true,  icon: "fa-gauge" },
    { label: "Analytics & Forecasting", to: "/admin/analytics", end: false, icon: "fa-chart-pie" },
    { label: "Store Management",  to: "/admin/stores",          end: false, icon: "fa-store" },
    { label: "User Management",   to: "/admin/users",           end: false, icon: "fa-users" },
    { label: "Master Price Book", to: "/admin/barcode-mapping", end: false, icon: "fa-book" },
    { label: "Wholesale Price Book", to: "/admin/wholesale-price-book", end: false, icon: "fa-boxes-stacked" },
    { label: "Purchase Records",  to: "/admin/purchase-records", end: false, icon: "fa-cart-shopping" },
    { label: "Sale Records",      to: "/admin/sale-records",    end: false, icon: "fa-cash-register" },
];

const AdminSidebar = ({ user, headerRef, showHeader, logoutUser, handleClick }) => {
    return (
        <>
            {/* Mobile backdrop */}
            {showHeader && (
                <div
                    className="fixed inset-0 bg-black/40 z-[99999999] lg:hidden backdrop-blur-sm"
                    onClick={handleClick}
                />
            )}

            {/* Sidebar panel */}
            <div
                ref={headerRef}
                className={`w-[78vw] sm:w-[320px] lg:w-[240px] fixed h-[100vh] top-0 left-0 z-[100000000] transition-transform duration-300 ease-in-out
                    ${showHeader ? "translate-x-0" : "-translate-x-full"}`}
            >
                <div className="w-full h-full bg-white flex flex-col shadow-2xl lg:shadow-[4px_0_24px_rgba(0,0,0,0.06)]">

                    {/* Header — Logo + Close */}
                    <div className="flex items-center justify-between px-4 pt-5 pb-3 border-b border-slate-100">
                        <NavLink to="/admin" onClick={handleClick}>
                            <img src={Logo} alt="logo" className="h-8 object-contain" />
                        </NavLink>
                        <button
                            onClick={handleClick}
                            className="w-8 h-8 rounded-lg bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-500 transition-colors"
                        >
                            <i className="fa-solid fa-xmark text-sm" />
                        </button>
                    </div>

                    {/* Admin badge */}
                    <div className="mx-4 mt-3 px-3 py-2 rounded-xl bg-gradient-to-r from-[#5f2dde]/10 to-[#DB2426]/10 border border-[#5f2dde]/20 flex items-center gap-2">
                        <i className="fa-solid fa-shield-halved text-[#5f2dde] text-xs" />
                        <span className="text-xs font-bold text-[#5f2dde] tracking-wide uppercase">Admin Panel</span>
                    </div>

                    {/* Navigation */}
                    <nav className="flex-1 overflow-y-auto py-3 my-scroll">
                        <div className="mb-2">
                            <div className="flex items-center gap-2 px-4 py-1.5 mb-1">
                                <span className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Management</span>
                                <div className="flex-1 h-px bg-slate-100" />
                            </div>

                            {NAV.map(({ label, to, end, icon }) => (
                                <NavLink
                                    key={to}
                                    to={to}
                                    end={end}
                                    onClick={handleClick}
                                    className={({ isActive }) =>
                                        `group flex items-center gap-3 px-4 py-2.5 rounded-xl mx-3 my-0.5 transition-all duration-200 relative overflow-hidden
                                        ${isActive
                                            ? "bg-gradient-to-r from-[#5f2dde] to-[#DB2426] text-white shadow-md"
                                            : "text-slate-600 hover:bg-purple-50 hover:text-[#5f2dde]"
                                        }`
                                    }
                                >
                                    {({ isActive }) => (
                                        <>
                                            <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0 transition-all
                                                ${isActive
                                                    ? "bg-white/20 text-white"
                                                    : "bg-slate-100 text-slate-500 group-hover:bg-purple-100 group-hover:text-[#5f2dde]"
                                                }`}
                                            >
                                                <i className={`fa-solid ${icon}`} />
                                            </span>
                                            <span className="font-semibold text-sm leading-none">{label}</span>
                                            {isActive && (
                                                <span className="ml-auto w-1.5 h-1.5 rounded-full bg-white/70 flex-shrink-0" />
                                            )}
                                        </>
                                    )}
                                </NavLink>
                            ))}
                        </div>
                    </nav>

                    {/* User card */}
                    <div className="border-t border-slate-100 p-3">
                        <div className="flex items-center gap-3 p-3 rounded-xl bg-slate-50 hover:bg-slate-100 transition-colors">
                            <div className="relative flex-shrink-0">
                                <img
                                    src={user?.avatar_url || Avatar}
                                    alt=""
                                    className="w-9 h-9 rounded-full object-cover ring-2 ring-purple-200"
                                />
                                <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-400 rounded-full border-2 border-white" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-bold text-slate-800 truncate">{user?.name}</p>
                                <p className="text-xs text-[#5f2dde] font-semibold truncate">{user?.role}</p>
                            </div>
                            <button
                                onClick={logoutUser}
                                title="Logout"
                                className="w-8 h-8 rounded-lg bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center flex-shrink-0 transition-colors"
                            >
                                <i className="fa-solid fa-arrow-right-from-bracket text-xs" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminSidebar;
